import api from '../lib/api';

export interface SlackConfig {
  botToken: string;
  signingSecret: string;
  defaultChannel?: string;
}

export interface SlackStatus {
  connected: boolean;
  lastSync?: Date;
  defaultChannel?: string;
  teamName?: string;
}

export interface SlackChannel {
  id: string;
  name: string;
  isPrivate: boolean;
}

export const slackService = {
  async connect(organizationId: string, config: SlackConfig) {
    const response = await api.post('/integrations/slack/connect', {
      organizationId,
      config,
    });
    return response.data;
  },

  async testConnection(organizationId: string) {
    const response = await api.get(`/integrations/slack/${organizationId}/test`);
    return response.data;
  },

  async getStatus(organizationId: string): Promise<SlackStatus> {
    const response = await api.get(`/integrations/slack/${organizationId}/status`);
    return response.data;
  },

  async fetchChannels(organizationId: string) {
    const response = await api.get(`/integrations/slack/${organizationId}/channels`);
    return response.data;
  },

  async fetchUsers(organizationId: string) {
    const response = await api.get(`/integrations/slack/${organizationId}/users`);
    return response.data;
  },

  async sendTestNotification(organizationId: string, channelId: string) {
    const response = await api.post(
      `/integrations/slack/${organizationId}/test-notification`,
      { channelId }
    );
    return response.data;
  },

  async updateDefaultChannel(organizationId: string, channelId: string) {
    const response = await api.post(
      `/integrations/slack/${organizationId}/update-channel`,
      { channelId }
    );
    return response.data;
  },

  async disconnect(organizationId: string) {
    const response = await api.post(`/integrations/slack/${organizationId}/disconnect`);
    return response.data;
  },
};
